import React from 'react';
import {
  MultiMediaResponse,
} from 'dtos';
import {
  getMediaType,
} from 'utils/misc';
import usePreviewMediaClick from 'pages/Dashboard/hooks/usePreviewMediaClick';
import PatientMetaData from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/PatientMetaData';

type Props = {
  data: MultiMediaResponse[];
  className?: string;
};

export default function MultiMediaList({
  data,
  className,
}: Props) {
  const handleMediaClick = usePreviewMediaClick();
  return (
    <div className={className}>
      {data?.map((item: MultiMediaResponse) => (
        <PatientMetaData
          key={item?.mediaId}
          title={item?.fileName ?? ''}
          onClick={() => { handleMediaClick(item); }}
          mediaType={getMediaType(item)}
        />
      ))}
    </div>
  );
}
